export default "/images/vendor/flag-icon-css/flags/4x3/ni.svg?d30c03773b8ce54120334c712f6c79f9";